<template>
  <div id="app">
    <NavBar/>
    <transition
      name="fade"
      mode="out-in">
      <Loader
        v-if="loaderVisible"
        :global="true"/>
    </transition>
    <transition
      name="fade"
      mode="out-in">
      <router-view/>
    </transition>
    <notifications position="top center" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NavBar from '@/components/page/NavBar';
import Loader from '@/components/page/Loader';

export default {
  name: 'App',
  components: {
    NavBar,
    Loader,
  },
  data() {
    return {
      loaderTimeout: null,
      loaderVisible: false,
      loaderHideOffsetMS: 200,
    };
  },
  computed: {
    ...mapState([
      'processes',
    ]),
  },
  watch: {
    processes(val) {
      clearTimeout(this.loaderTimeout);
      if (val) {
        this.loaderVisible = true;
        return;
      }
      this.loaderTimeout = setTimeout(() => {
        this.loaderVisible = false;
      }, this.loaderHideOffsetMS);
    },
  },
};
</script>

<style lang="scss" src="./assets/scss/global.scss"></style>



// WEBPACK FOOTER //
// src/App.vue